import { useState, useEffect } from 'react';
import Papa from 'papaparse';

import marketCsvUrl from '../assets/us_market.csv?url';
import logoCsvUrl from '../assets/complete_us_stock_FINAL.csv?url';

export const useStockData = () => {
  const [stockDataMap, setStockDataMap] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadStockData = async () => {
      try {
        console.log(' Loading stock data...');
        
        const [marketResponse, logoResponse] = await Promise.all([
          fetch(marketCsvUrl), 
          fetch(logoCsvUrl)  
        ]);
        
        if (!marketResponse.ok) {
          throw new Error('Failed to fetch us_market.csv');
        }
        
        const marketText = await marketResponse.text();
        const logoText = logoResponse.ok ? await logoResponse.text() : '';


        let logoMap = new Map();
        
        if (logoText) {
          Papa.parse(logoText, {
            header: true,
            skipEmptyLines: true,
            transformHeader: (header) => header.trim(),
            complete: (logoResults) => {
              console.log('Logo CSV parsed:', logoResults.data.length, 'rows');
              
              logoResults.data.forEach((row) => {
                if (row.symbol && row.logo_url) {
                  let symbol = row.symbol.trim().toUpperCase();
                  
                  if (symbol.includes(':')) {
                    symbol = symbol.split(':')[1];
                  }
                  
                  const logoUrl = row.logo_url.trim();
                  
                  if (logoUrl && logoUrl.startsWith('http')) {
                    logoMap.set(symbol, logoUrl);
                  }
                }
              });
              
              console.log(' Valid logos found:', logoMap.size);
              
              if (logoMap.size > 0) {
                const samples = Array.from(logoMap.entries()).slice(0, 5);
                console.log('Sample logos:', samples);
              }
            }
          });
        }

        Papa.parse(marketText, {
          header: true,
          dynamicTyping: true,
          skipEmptyLines: true,
          transformHeader: (header) => header.trim(),
          complete: (results) => {
            const stockMap = new Map();
            
            results.data.forEach((row) => {
              if (row.name && row.description && typeof row.name === 'string') {
                const symbol = row.name.trim().toUpperCase();
                const logoUrl = logoMap.get(symbol);
                
                stockMap.set(symbol, {
                  name: row.name,
                  description: row.description,
                  exchange: row.exchange || row.market || 'NASDAQ',
                  sector: row.sector,
                  market_cap: row.market_cap_basic,
                  logo_url: logoUrl || null
                });
              }
            });
            
            const withLogos = Array.from(stockMap.values()).filter(s => s.logo_url).length;
            
            setStockDataMap(stockMap);
            setIsLoading(false);
            
            console.log(' Stock data loaded:', stockMap.size, 'symbols');
            console.log(' Symbols with logos:', withLogos);
            
            if (withLogos > 0) {
              const samples = Array.from(stockMap.entries())
                .filter(([_, data]) => data.logo_url)
                .slice(0, 3);
              console.log('Sample stocks with logos:');
              samples.forEach(([symbol, data]) => {
                console.log(`  ${symbol}: ${data.logo_url}`);
              });
            }
          },
          error: (err) => {
            console.error(' Error parsing market CSV:', err);
            setError(err.message);
            setIsLoading(false);
          }
        });
      } catch (err) {
        console.error(' Error loading data:', err);
        setError(err.message);
        setIsLoading(false);
      }
    };

    loadStockData();
  }, []);

  return { stockDataMap, isLoading, error };
};